import React, { useState } from 'react'
import Select from 'react-select'
import makeAnimated from 'react-select/animated'
import Checkbox from '@mui/material/Checkbox'
import ErrorBox from '@/components/subComponents/errorBox/'
import { assets } from '@/helpers/common'
import Icon from '@/@core/components/icon'
import { has } from 'lodash'
import Link from 'next/link'
import { isEmpty } from 'validator'

const RegForm = function (props) {
  const [showPassword, setShowPassword] = useState(false)

  const getStateFields = () => {
    let isLoading = props.states.length === 0
    if (props.formData.country_id === 226) {
      return (
        <div className={has(props.formErrors, 'state_id') ? 'input-group has-error' : 'input-group'}>
          <Select
            className='input-field select-two-wrapper'
            name='state_id'
            components={animatedComponents}
            placeholder={'Select State'}
            isDisabled={isLoading}
            isLoading={isLoading}
            getOptionLabel={option => option.state}
            getOptionValue={option => option.state_id}
            options={props.states}
            onChange={item => props.setCountryState(item)}
            autoComplete='off'
          />
          {has(props.formErrors, 'state_id') ? <span className='error'>{props.formErrors.state_id}</span> : ''}
        </div>
      )
    }
  }

  function getUnknownErrors() {
    if (props.showError === true && props.formErrors.status === false && !isEmpty(props.formErrors.message))
      return <ErrorBox message={props.formErrors.message} />
  }

  const animatedComponents = makeAnimated()

  return (
    <div className='register-form-box w-full py-10 px-16 xs:py-5 xs:px-5 shadow-2xl'>
      <form className='row' onSubmit={e => props.formOnSubmitHandler(e)} autoComplete='off'>
        <div className='form-left w-4/12 md-mx:w-full'>
          <div className='section-title'>
            <h2>Create An Account</h2>
            <p>Please use your work email address</p>
          </div>

          {getUnknownErrors()}

          <div className='form-fields'>
            <div className={has(props.formErrors, 'first_name') ? 'input-group has-error' : 'input-group'}>
              <input
                type='text'
                name='first_name'
                className='input-field'
                placeholder='First Name'
                value={props.formData.first_name}
                autoComplete='off'
                onChange={e => props.inputOnChangeHandler(e)}
              />
              {has(props.formErrors, 'first_name') ? <span className='error'>{props.formErrors.first_name}</span> : ''}
            </div>
            <div className={has(props.formErrors, 'last_name') ? 'input-group has-error' : 'input-group'}>
              <input
                type='text'
                name='last_name'
                className='input-field'
                placeholder='Last Name'
                value={props.formData.last_name}
                autoComplete='off'
                onChange={e => props.inputOnChangeHandler(e)}
              />
              {has(props.formErrors, 'last_name') ? <span className='error'>{props.formErrors.last_name}</span> : ''}
            </div>
            <div className={has(props.formErrors, 'email') ? 'input-group has-error' : 'input-group'}>
              <input
                type='text'
                name='email'
                className='input-field'
                placeholder='Email Address'
                value={props.formData.email}
                autoComplete='on'
                onChange={e => props.inputOnChangeHandler(e)}
              />
              {has(props.formErrors, 'email') ? <span className='error'>{props.formErrors.email}</span> : ''}
            </div>

            <div className={has(props.formErrors, 'password') ? 'input-group has-error' : 'input-group'}>
              <input
                type={showPassword ? 'text' : 'password'}
                name='password'
                className='input-field'
                placeholder='Password'
                autoComplete='on'
                value={props.formData.password}
                onChange={e => props.inputOnChangeHandler(e)}
              />
              <span className='text-view' onClick={() => setShowPassword(!showPassword)}>
                <Icon icon='mdi:eye' fontSize={22} />
              </span>
              {has(props.formErrors, 'password') ? <span className='error'>{props.formErrors.password}</span> : ''}
            </div>
            <div className={has(props.formErrors, 'country_id') ? 'input-group has-error' : 'input-group'}>
              <Select
                className='input-field select-two-wrapper'
                name='country_id'
                components={animatedComponents}
                placeholder={'Select Country'}
                getOptionLabel={option => option.country}
                getOptionValue={option => option.country_id}
                options={props.countries}
                onChange={item => props.setCountry(item)}
              />
              {has(props.formErrors, 'country_id') ? <span className='error'>{props.formErrors.country_id}</span> : ''}
            </div>
            {getStateFields()}
            <div
              className={
                has(props.formErrors, 'accept') ? 'input-group checkbox-group has-error' : 'input-group checkbox-group'
              }
            >
              <Checkbox
                checked={!!props.formData?.accept}
                value={!!props.formData?.accept}
                name='accept'
                onChange={props.inputOnChangeHandler}
              />
              <p>I agree with the terms & conditions</p>
            </div>
            <div className='input-group'>
              <button type='submit' className='btn btn-primary w-full'>
                Sign Up
              </button>
            </div>
            {props.loading ? (
              <div className='loading'>
                <img src={assets('images/loading.svg')} alt={''} />
              </div>
            ) : (
              ''
            )}
          </div>

          <div className='input-group'>
            <p className=' text-sm15 text-primary text-center mt-3'>
              Already have an account?{' '}
              <Link href='/login' className=' text-lg font-medium text-secondary underline'>
                Login
              </Link>
            </p>
          </div>
        </div>
        <div className='form-right w-8/12 md-mx:hidden'>
          <img src={assets('images/register-image.png')} alt='login' />
        </div>
      </form>
    </div>
  )
}

export default RegForm
